import { omit, isNil } from 'lodash-es'

export function FormatForm({ formValues, company, questionnaireType, building, formFile }) {
  const formData = new FormData()
  const forms = {
    building_id: building.id,
    property_manager_id: building.org.id,
    ...omit(formValues, ['units', 'unit']),
    company_name: formValues.company_name || company?.name,
  }
  if (formFile?.customForm) {
    // Uploading a new file
    !isNil(company?.id) && formData.append(`questionnaire_request[questionnaire_issuer_id]`, company.id)
    !isNil(company?.name) && formData.append(`questionnaire_request[questionnaire_issuer_name]`, company?.name)
    !isNil(questionnaireType?.key) && formData.append(`questionnaire_request[questionnaire_issuer_type]`, questionnaireType?.key)

    // Sandbox File ID
    !isNil(formFile?.id) && formData.append(`questionnaire_request[questionnaire_form]`, formFile?.id)
  } else {
    if (formFile?.standardForm) {
      !isNil(formFile?.id) && formData.append(`questionnaire_request[form_id]`, formFile?.id)
    } else {
      // Selecting an existing form
      !isNil(formFile?.id) && formData.append(`questionnaire_request[questionnaire_form_id]`, formFile?.id)
    }
  }
  Object.keys(forms).forEach((key) => {
    !isNil(forms[key]) && formData.append(`questionnaire_request[${key}]`, forms[key])
  })
  return formData
}

export function FormatError(errors) {
  const newErrors = {}
  Object.keys(errors)?.forEach((key) => {
    newErrors[key] = errors[key].join(',')
  })
  return newErrors
}

export function FormatFormFile({ file, pdfUrl, fileName, customForm, standardForm, pageUrls = [] }) {
  return {
    ...file,
    pdf_url: pdfUrl,
    page_urls: pageUrls,
    file_name: fileName,
    customForm,
    standardForm,
  }
}
